// extracted by mini-css-extract-plugin
export default {"error":"styles_error__Crh6j","error__message":"styles_error__message__4UKgB"};